type AdjustmentInfo = {
  title: string
  description: string
  options?: {
    value: string
    description: string
  }[]
}

export const adjustmentInfo: AdjustmentInfo[] = [
  {
    title: "method",
    description: "Method used to calculate prayer times.",
    options: [
      {
        value: "MuslimWorldLeague",
        description:
          "Muslim World League. Standard Fajr time with an angle of 18°. Earlier Isha time with an angle of 17°.",
      },
      {
        value: "Egyptian",
        description:
          "Egyptian General Authority of Survey. Early Fajr time using an angle 19.5° and a slightly earlier Isha time using an angle of 17.5°.",
      },
      {
        value: "Karachi",
        description:
          "University of Islamic Sciences, Karachi. A generally applicable method that uses standard Fajr and Isha angles of 18°.",
      },
      {
        value: "UmmAlQura",
        description:
          "Umm al-Qura University, Makkah. Uses a fixed interval of 90 minutes from maghrib to calculate Isha. And a slightly earlier Fajr time with an angle of 18.5°. Note: you should add a +30 minute custom adjustment for Isha during Ramadan.",
      },
      {
        value: "Dubai",
        description:
          "Used in the UAE. Slightly earlier Fajr time and slightly later Isha time with angles of 18.2° for Fajr and Isha in addition to 3 minute offsets for sunrise, Dhuhr, Asr, and Maghrib.",
      },
      {
        value: "Qatar",
        description:
          "Same Isha interval as Umm Al Qura but with the standard Fajr time using an angle of 18°.",
      },
      {
        value: "Kuwait",
        description:
          "Standard Fajr time with an angle of 18°. Slightly earlier Isha time with an angle of 17.5°.",
      },
      {
        value: "MoonsightingCommittee",
        description:
          "Method developed by Khalid Shaukat, founder of Moonsighting Committee Worldwide. Uses standard 18° angles for Fajr and Isha in addition to seasonal adjustment values. This method automatically applies the 1/7 approximation rule for locations above 55° latitude. Recommended for North America and the UK.",
      },
      {
        value: "Singapore",
        description:
          "Used in Singapore, Malaysia, and Indonesia. Early Fajr time with an angle of 20° and standard Isha time with an angle of 18°.",
      },
      {
        value: "Turkey",
        description:
          "An approximation of the Diyanet method used in Turkey. This approximation is less accurate outside the region of Turkey.",
      },
      {
        value: "Tehran",
        description:
          "Institute of Geophysics, University of Tehran. Early Isha time with an angle of 14°. Slightly later Fajr time with an angle of 17.7°. Calculates Maghrib based on the sun reaching an angle of 4.5° below the horizon.",
      },
      {
        value: "NorthAmerica",
        description:
          "Also known as the ISNA method. Can be used for North America, but the Moonsighting Committee method is preferable. Gives later Fajr times and early Isha times with angles of 15°.",
      },
      {
        value: "Other",
        description:
          "Defaults to angles of 0°, should generally be used for making a custom method and setting your own values.",
      },
    ],
  },
  {
    title: "fajrAngle",
    description: "Angle of the sun used to calculate Fajr.",
  },
  {
    title: "maghribAngle",
    description:
      "Angle of the sun used to calculate Maghrib (this is used by the Tehran method).",
  },
  {
    title: "ishaAngle",
    description: "Angle of the sun used to calculate Isha.",
  },
  {
    title: "ishaInterval",
    description:
      "Minutes after Maghrib (if set, the time for Isha will be Maghrib time plus the interval you have set).",
  },
  {
    title: "madhab",
    description: "Used to calculate Asr. Shafi is the default value.",
    options: [
      {
        value: "Shafi",
        description: "Earlier Asr time",
      },
      {
        value: "Hanafi",
        description: "Later Asr time",
      },
    ],
  },
  {
    title: "highLatitudeRule",
    description: "Used to set a minimum time for Fajr and a max time for Isha.",
    options: [
      {
        value: "MiddleOfTheNight",
        description:
          "Fajr will never be earlier than the middle of the night and Isha will never be later than the middle of the night.",
      },
      {
        value: "SeventhOfTheNight",
        description:
          "Fajr will never be earlier than the beginning of the last seventh of the night and Isha will never be later than the end of the first seventh of the night. This is recommended to use for locations above 48° latitude to prevent prayer times that would be difficult to perform.",
      },
      {
        value: "TwilightAngle",
        description:
          "The night is divided into portions of roughly 1/3. The exact value is derived by dividing the fajr/isha angles by 60. This can be used to prevent difficult fajr and isha times at certain locations.",
      },
    ],
  },
  {
    title: "rounding",
    description:
      "The behavior for rounding prayer times. Either to nearest minute, to the higher minute, or none. Nearest is the default value.",
  },
  {
    title: "polarCircleResolution",
    description:
      "Strategy used to resolve undefined prayer times for areas located in polar circles. Unresolved is the default value.",
    options: [
      {
        value: "AqrabBalad",
        description:
          "Finds the closest location for which sunrise and sunset prayer times can be computed.",
      },
      {
        value: "AqrabYaum",
        description:
          "Finds the closest date (forward or backward) for which sunrise and sunset prayer times can be computed.",
      },
      {
        value: "Unresolved",
        description:
          "(default) Leaves sunrise and sunset prayer times undefined when they can't be computed.",
      },
    ],
  },
  {
    title: "shafaq",
    description:
      "Shafaq is used by the Moonsighting Committee method to determine what type of twilight to use in order to determine the time for Isha.",
    options: [
      {
        value: "General",
        description:
          "General is a combination of Ahmer and Abyad. This is the defualt value and will provide more reasonable times for locations at higher latitudes.",
      },
      {
        value: "Ahmer",
        description:
          "Ahmer means the twilight is the red glow in the sky. Used by the Shafi, Maliki, and Hanbali madhabs. This generally produces an earlier Isha time.",
      },
      {
        value: "Abyad",
        description:
          "Abyad means the twilight is the white glow in the sky. Used by the Hanafi madhab. This generally produces a later Isha time.",
      },
    ],
  },
]
